export default __webpack_public_path__ + "static/media/004-B-tv.a15a1391.svg";